var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13261_50003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 20.1798C6.8125 22.0123 5.318 23.5091 3.48525 23.5091C1.6525 23.5091 0.15625 22.0123 0.15625 20.1798C0.15625 18.3473 1.653 16.8506 3.4855 16.8506H6.81275L6.8125 20.1798ZM8.48975 20.1798C8.48975 18.3473 9.9865 16.8506 11.819 16.8506C13.6515 16.8506 15.1482 18.3471 15.1482 20.1798V28.5136C15.1482 30.3461 13.6517 31.8428 11.819 31.8428C9.9865 31.8428 8.48975 30.3461 8.48975 28.5136V20.1798Z",
    fill: "#DE1C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.819 6.81372C9.9865 6.81372 8.48975 5.31922 8.48975 3.48647C8.48975 1.65372 9.9865 0.157471 11.819 0.157471C13.6515 0.157471 15.1482 1.65422 15.1482 3.48672V6.81397L11.819 6.81372ZM11.819 8.49097C13.6515 8.49097 15.1482 9.98772 15.1482 11.8202C15.1482 13.6527 13.6517 15.1495 11.819 15.1495H3.48525C1.65275 15.1495 0.15625 13.653 0.15625 11.8202C0.15625 9.98772 1.653 8.49097 3.4855 8.49097H11.819Z",
    fill: "#35C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1873 11.8202C25.1873 9.98772 26.6818 8.49097 28.5146 8.49097C30.3473 8.49097 31.8438 9.98772 31.8438 11.8202C31.8438 13.6527 30.3471 15.1495 28.5146 15.1495H25.1873V11.8202ZM23.5101 11.8202C23.5101 13.6527 22.0133 15.1495 20.1808 15.1495C18.3483 15.1495 16.8516 13.653 16.8516 11.8202V3.48647C16.8516 1.65397 18.3481 0.157471 20.1808 0.157471C22.0133 0.157471 23.5101 1.65422 23.5101 3.48672V11.8202Z",
    fill: "#2EB57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1808 25.1863C22.0133 25.1863 23.5101 26.6808 23.5101 28.5136C23.5101 30.3463 22.0133 31.8428 20.1808 31.8428C18.3483 31.8428 16.8516 30.3461 16.8516 28.5136V25.1863H20.1808ZM20.1808 23.5091C18.3483 23.5091 16.8516 22.0123 16.8516 20.1798C16.8516 18.3473 18.3481 16.8506 20.1808 16.8506H28.5146C30.3471 16.8506 31.8438 18.3471 31.8438 20.1798C31.8438 22.0123 30.3471 23.5091 28.5146 23.5091H20.1808Z",
    fill: "#EBB02E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13261_50003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.59b047005ddf8ff512d3564620e46b5b.svg";
export { ForwardRef as ReactComponent };